// src/constants/preferenceCategories.js

const preferenceCategories = {
  "Qualities / Personality Traits": [
    "Honest",
    "Loyal",
    "Ambitious",
    "Introverted",
    "Romantic",
    "Open-minded",
    "Calm",
    "Confident",
    "Empathetic",
    "Spontaneous",
    "Emotionally Available",
  ],

  "Lifestyle Preferences": [
    "Smoker",
    "Drinks Alcohol",
    "Drinks on Social Occasions",
    "Vegetarian",
    "Vegan",
    "Pet Lover",
    "Active Lifestyle (Outdoor activities)",
    "Enjoys being at Home",
    "Wants Kids",
    "Career-Focused",
    "Work-Life Balance",
  ],

  "Relationship Goals": [
    "Long-Term Relationship",
    "Open to Marriage",
    "Short-Term Dating",
    "Casual / No Strings Attached",
    "Just Want to Make Friends",
    "Open to Anything",
  ],

  "Hobbies & Interests": [
    "Traveling",
    "Cooking",
    "Fitness / Gym",
    "Hiking",
    "Yoga / Meditation",
    "Swimming",
    "Reading",
    "Writing",
    "Journaling",
    "Photography",
    "Music",
    "Singing",
    "Video Games",
    "Board Games",
    "DIY / Crafts",
    "Dancing",
    "Art / Painting",
    "Gardening",
    "Watching Movies",
    "Collecting",
    "Attending Events",
    "Biking",
    "Sports",
    "Volunteering",
    "Fashion",
    "Tech / Gadgets",
  ],

  "Cultural / Values": [
    "Open to Interfaith",
    "Open to All Ethnic Backgrounds",
    "Open to Relocating",
    "Traditional Gender Roles",
    "Modern / Equal Roles",
    "Liberal Views",
    "Conservative Views",
    "Moderate Views",
    "Apolitical",
  ],
};

export default preferenceCategories;
